<svg width="140" height="89" viewBox="0 0 140 89" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="139" height="88" rx="3.5" fill="currentColor" stroke="#BBBFC3"/>
    <rect x="3" y="3" width="65" height="36" rx="2" fill="#BBBFC3"/>
    <rect x="118.5" y="70" width="17" height="16" rx="2" fill="#BBBFC3"/>
    <rect x="3" y="41" width="43" height="27" rx="2" fill="#BBBFC3"/>
    <rect x="4.5" y="70" width="17" height="16" rx="2" fill="#BBBFC3"/>
    <rect x="42.5" y="70" width="17" height="16" rx="2" fill="#BBBFC3"/>
    <rect x="80.5" y="70" width="17" height="16" rx="2" fill="#BBBFC3"/>
    <rect x="23.5" y="70" width="17" height="16" rx="2" fill="#BBBFC3"/>
    <rect x="61.5" y="70" width="17" height="16" rx="2" fill="#BBBFC3"/>
    <rect x="99.5" y="70" width="17" height="16" rx="2" fill="#BBBFC3"/>
    <rect x="48" y="41" width="44" height="27" rx="2" fill="#BBBFC3"/>
    <rect x="94" y="41" width="43" height="27" rx="2" fill="#BBBFC3"/>
    <rect x="70" y="3" width="67" height="36" rx="2" fill="#BBBFC3"/>
</svg>
